import { render, staticRenderFns } from "./form.component.vue?vue&type=template&id=5b7a0c08&scoped=true"
import script from "./form.component.vue?vue&type=script&lang=js"
export * from "./form.component.vue?vue&type=script&lang=js"
import style0 from "./form.component.vue?vue&type=style&index=0&id=5b7a0c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a0c08",
  null
  
)

export default component.exports